(function loginControllerDefinition() {
    'use strict';

    angular.module('LoginPage')
        .controller('LoginPageController', [
            '$scope', 'config', '$state', '$stateParams',
            function loginPageController($scope, config, $state, $stateParams) {
                if ($stateParams.confirmed) {
                    $scope.showConfirmed = true;
                }
                $scope.loginResult = function (result) {
                    return result;
                };
            }
        ]);
})();